import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  Col,
  Collapse,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import "../../assets/scss/components/LandingPage/index.scss";
import Icon from "react-icons-kit";
import { barChart } from "react-icons-kit/fa/barChart";
import { Bar, Pie } from "react-chartjs-2";
import {
  fetchBarGraphStatistics,
  fetchCustomerStatistics,
  fetchEventsStatistics,
  fetchPieChartStatistics,
  fetchRidesStatistics,
} from "../../redux/Statistics/actions";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/scss/components/CustomDatepicker/index.scss";
import { calendar } from "react-icons-kit/fa/calendar";
import get from "lodash/get";
import moment from "moment";
import history from "../../history";
import CustomButton from "../CustomButton";
import InputText from "../InputText";
import CustomDatepicker from "../CustomDatepicker";
import { toast } from "react-toastify";
import CartTitle from "../CartTitle";

const _ = { get };

const LandingPage = () => {
  const dispatch = useDispatch();
  const {
    pieChartStatistics,
    customerStatistics,
    eventsStatistics,
    ridesStatistics,
  } = useSelector((state) => state.statistics);
  const { elements } = useSelector((state) => state.Elements);
  const { countries } = useSelector((state) => state.Global);
  const { accessibleCountries } = useSelector(
    (state) => state.Auth.userProfile
  );

  const [yearlyEvents, setYearlyEvents] = useState(null);
  const [yearlyEventPaticipants, setYearlyEventPaticipants] = useState(null);
  const [yearlyRides, setYearlyRides] = useState(null);
  const [yearlyRideParticipants, setYearlyRideParticipants] = useState(null);
  const [toggleActive, setToggleActive] = useState(true);
  const [toggleCollapse, setToggleCollapse] = useState(false);
  const [country, setCountry] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [parsedCountry, setParsedCountry] = useState("");

  const branchesData = {
    labels: [
      _.get(elements, "landingPageElement.approvedPieElement", "Approved"),
      _.get(elements, "landingPageElement.rejectedPieElement", "Rejected"),
      _.get(elements, "landingPageElement.pendingPieElement", "Pending"),
    ],
    datasets: [
      {
        label: "Branches",
        data: pieChartStatistics
          ? [
              pieChartStatistics &&
                pieChartStatistics.branches &&
                pieChartStatistics.branches.branchApprovedCount,
              pieChartStatistics &&
                pieChartStatistics.branches &&
                pieChartStatistics.branches.branchRejectedCount,
              pieChartStatistics &&
                pieChartStatistics.branches &&
                pieChartStatistics.branches.branchPendingCount,
            ]
          : [0, 0, 0],
        fill: true,
        backgroundColor: ["#da291c", "#5d5d5d", "#D99F3A"],
        backgroundColor: ["#da291c", "#5d5d5d", "#D99F3A"],
        hoverBackgroundColor: ["#da291c", "#5d5d5d", "#D99F3A"],
      },
    ],
  };

  console.log("customerStatistics", customerStatistics);

  const customersData = {
    labels: [
      _.get(elements, "landingPageElement.dashboardPieElement", "Dashboard"),
    ],
    datasets: [
      {
        label: "Customers",
        data: customerStatistics
          ? [
              customerStatistics &&
                customerStatistics.customers &&
                customerStatistics.customers.totalCustomers,
              // customerStatistics.customers.websiteCustomersCount,
              // customerStatistics.customers.appCustomersCount,
            ]
          : [0, 0, 0],
        fill: true,
        backgroundColor: ["#da291c"],
        backgroundColor: ["#da291c"],
        hoverBackgroundColor: ["#da291c"],
      },
    ],
  };

  const membersData = {
    labels: [
      _.get(elements, "landingPageElement.approvedPieElement", "Approved"),
      _.get(elements, "landingPageElement.rejectedPieElement", "Rejected"),
      _.get(elements, "landingPageElement.pendingPieElement", "Pending"),
      _.get(
        elements,
        "landingPageElement.unallocatedPieElement",
        "Unallocated"
      ),
    ],
    datasets: [
      {
        label: "Members",
        data: pieChartStatistics
          ? [
              pieChartStatistics &&
                pieChartStatistics.members &&
                pieChartStatistics.members.membersApprovedCount,
              pieChartStatistics &&
                pieChartStatistics.members &&
                pieChartStatistics.members.membersRejectedCount,
              pieChartStatistics &&
                pieChartStatistics.members &&
                pieChartStatistics.members.membersPendingCount,
              pieChartStatistics &&
                pieChartStatistics.members &&
                pieChartStatistics.members.membersUnallocatedCount,
            ]
          : [0, 0, 0, 0],
        fill: true,
        backgroundColor: ["#da291c", "#5d5d5d", "#D99F3A", "#000"],
        backgroundColor: ["#da291c", "#5d5d5d", "#D99F3A", "#000"],
        hoverBackgroundColor: ["#da291c", "#5d5d5d", "#D99F3A", "#000"],
      },
    ],
  };

  const labels = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const eventData = {
    labels,
    datasets: [
      {
        label: "No. of Participants",
        data: yearlyEventPaticipants ? yearlyEventPaticipants : [],
        borderColor: "rgb(255, 99, 132)",

        backgroundColor: "#DA291C",
      },
      {
        label: "No. of Events",
        data: yearlyEvents ? yearlyEvents : [],
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "#5D5D5D",
      },
    ],
  };

  const rideData = {
    labels,
    datasets: [
      {
        label: "No. of Participants",
        data: yearlyRideParticipants ? yearlyRideParticipants : [],
        borderColor: "rgb(255, 99, 132)",

        backgroundColor: "#DA291C",
      },
      {
        label: "No. of Rides",
        data: yearlyRides ? yearlyRides : [],
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "#5D5D5D",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Chart.js Line Chart",
      },
    },
  };

  const yearlyParticipants = (data, setYearlyData, selectionString) => {
    if (data) {
      const yearlyEventParticipants = [];
      data.forEach((element) => {
        if (element._id) {
          if (
            yearlyEventParticipants &&
            yearlyEventParticipants.length === 12
          ) {
            yearlyEventParticipants[element._id.month - 1] =
              element[selectionString];
          } else {
            for (let i = 1; i <= 12; i++) {
              if (element._id.month === i) {
                yearlyEventParticipants.push(element[selectionString]);
              } else {
                if (yearlyEventParticipants) {
                  yearlyEventParticipants.push(0);
                } else {
                  yearlyEventParticipants = [0];
                }
              }
            }
          }
        }
      });
      console.log("yearly", yearlyEventParticipants);
      setYearlyData(yearlyEventParticipants);
    }
  };

  const handleToggle = (e) => {
    setToggleActive(!toggleActive);
    if (toggleCollapse === true) {
      setToggleCollapse(!toggleCollapse);
    }
  };

  const handleCountryChange = (e) => {
    if (e.target.value !== "") {
      let parsedValue = JSON.parse(e.target.value);
      let code = parsedValue.locality.country;
      let countryName = parsedValue.country;

      setCountry(countryName);
      setCountryCode(code);
    } else {
      setCountry("");
      setCountryCode("");
    }
    setParsedCountry(e.target.value);
  };

  const handleSearch = () => {
    let obj = {
      startDate: startDate ? moment(startDate).format("DD/MM/YYYY") : "",
      endDate: endDate ? moment(endDate).format("DD/MM/YYYY") : "",
      country: countryCode,
    };

    dispatch(fetchPieChartStatistics(obj));
    dispatch(fetchCustomerStatistics(obj));
    dispatch(fetchEventsStatistics(obj));
    dispatch(fetchRidesStatistics(obj));
  };

  const handleClearFilter = () => {
    let obj = {
      startDate: "",
      endDate: "",
      country: "",
    };
    setStartDate("");
    setEndDate("");
    setCountry("");
    setParsedCountry("");

    dispatch(fetchPieChartStatistics(obj));
    dispatch(fetchCustomerStatistics(obj));
    dispatch(fetchEventsStatistics(obj));
    dispatch(fetchRidesStatistics(obj));
  };

  useEffect(() => {
    // let newStartDate = new Date().setFullYear(new Date().getFullYear(), 0, 1);
    // let newEndDate = new Date().setFullYear(new Date().getFullYear(), 11, 31);
    let newStartDate = new Date("04/01/2021");
    let newEndDate = new Date().setFullYear(new Date().getFullYear());
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    let obj = {
      startDate: newStartDate ? moment(newStartDate).format("DD/MM/YYYY") : "",
      endDate: newEndDate ? moment(newEndDate).format("DD/MM/YYYY") : "",
      country: countryCode,
    };
    dispatch(fetchPieChartStatistics(obj));
    dispatch(fetchCustomerStatistics(obj));
    dispatch(fetchEventsStatistics(obj));
    dispatch(fetchRidesStatistics(obj));
  }, []);

  useEffect(() => {
    if (accessibleCountries && countries && countries.length !== 0) {
      if (accessibleCountries.length === 1 && accessibleCountries[0] === "*") {
        setCountryList(countries);
      } else if (
        accessibleCountries.length === 1 &&
        accessibleCountries[0] !== "*"
      ) {
        let newCountry = countries.filter((data) =>
          accessibleCountries.includes(data.locality.country)
        );
        setCountryList(newCountry);
        let code = newCountry[0].locality.country;
        let countryName = newCountry[0].country;

        setCountry(countryName);
        setCountryCode(code);
      } else {
        setCountryList(
          countries.filter((data) =>
            accessibleCountries.includes(data.locality.country)
          )
        );
      }
    }
  }, [accessibleCountries, countries]);

  useEffect(() => {
    if (eventsStatistics && eventsStatistics.events) {
      yearlyParticipants(
        eventsStatistics &&
          eventsStatistics.events &&
          eventsStatistics.events.eventsParticipants,
        setYearlyEventPaticipants,
        "eventParticipants"
      );
      yearlyParticipants(
        eventsStatistics &&
          eventsStatistics.events &&
          eventsStatistics.events.monthlyEvents,
        setYearlyEvents,
        "eventsCount"
      );
    }
    if (ridesStatistics && ridesStatistics.rides) {
      yearlyParticipants(
        ridesStatistics &&
          ridesStatistics.rides &&
          ridesStatistics.rides.ridesParticipants,
        setYearlyRideParticipants,
        "ridesParticipants"
      );
      yearlyParticipants(
        ridesStatistics &&
          ridesStatistics.rides &&
          ridesStatistics.rides.monthlyRides,
        setYearlyRides,
        "ridesCount"
      );
    }
  }, [eventsStatistics, ridesStatistics]);

  console.log("country", countryList);

  return (
    <>
      <div className="mt-4 px-3 pb-3">
        <Row>
          <Col sm={12}>
            <CartTitle
              title={_.get(
                elements,
                "landingPageElement.headingElement",
                "Riders Club Europe - Dashboard"
              )}
              Name={_.get(
                elements,
                "landingPageElement.filterButtonElement",
                "Filter"
              )}
              iconClass={"hideexcel"}
              handleToggle={() => handleToggle()}
            />
          </Col>
          <Col sm={12}>
            <Collapse isOpen={toggleActive}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col xl={4} lg={4} md={6} sm={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "landingPageElement.selectCountryLabelElement",
                          "Select Country"
                        )}{" "}
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        {accessibleCountries &&
                        accessibleCountries.length === 1 &&
                        accessibleCountries[0] !== "*" ? (
                          <Input
                            type="select"
                            name="City"
                            className="w-100 customeSelectBtn"
                            value={parsedCountry}
                            onChange={(e) => handleCountryChange(e)}
                          >
                            {countryList &&
                              countryList.length > 0 &&
                              countryList
                                .sort((a, b) =>
                                  a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                                )
                                .map((item, index) => (
                                  <option
                                    key={index}
                                    value={JSON.stringify(item)}
                                  >
                                    {item.country}
                                  </option>
                                ))}
                          </Input>
                        ) : (
                          <Input
                            type="select"
                            name="Country"
                            className="w-100 customeSelectBtn"
                            value={parsedCountry}
                            onChange={(e) => handleCountryChange(e)}
                          >
                            <option value={""}>
                              {_.get(
                                elements,
                                "landingPageElement.countryLabel",
                                "All Countries"
                              )}
                            </option>

                            {countryList &&
                              countryList.length > 0 &&
                              countryList
                                .sort((a, b) =>
                                  a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                                )
                                .map((item, index) => (
                                  <option
                                    key={index}
                                    value={JSON.stringify(item)}
                                  >
                                    {item.country}
                                  </option>
                                ))}
                          </Input>
                        )}
                      </FormGroup>
                    </Col>
                    <Col lg={4} className="mb-3 mb-lg-0">
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "landingPageElement.startDateLabelElement",
                          "Start Date"
                        )}{" "}
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={startDate}
                          customPlaceHolder={_.get(
                            elements,
                            "landingPageElement.startDatePlaceHolderElement",
                            "Select Start Date"
                          )}
                          handleDateChange={(startDate) =>
                            setStartDate(startDate)
                          }
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                          customMaxDate={new Date()}
                          // customMinDate={new Date("04/01/2021")}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg={4} className="mb-3 mb-lg-0">
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "landingPageElement.endDateLabelElement",
                          "End Date"
                        )}
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={endDate}
                          customPlaceHolder={_.get(
                            elements,
                            "landingPageElement.endDatePlaceHolderElement",
                            "Select End Date"
                          )}
                          handleDateChange={(endDate) => setEndDate(endDate)}
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                          customMinDate={startDate}
                          // customMaxDate={new Date()}
                          customDisable={startDate === ""}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      lg={12}
                      className="d-flex align-items-center justify-content-end"
                    >
                      <div className="d-flex mt-3">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "landingPageElement.searchButtonElement",
                            "Search"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={() => handleSearch()}
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "landingPageElement.clearFilterButtonElement",
                            "Clear Filter"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={() => handleClearFilter()}
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Collapse>
          </Col>
        </Row>
        <Row>
          <Col className="Main-Graph-Card" xl={3} md={4} lg={4}>
            <div
              className="white-box shadow cardPointer"
              onClick={() => history.push("/reports/branches")}
            >
              <h3 className="box-title">
                {_.get(
                  elements,
                  "landingPageElement.branchesElement",
                  "Branches"
                )}
              </h3>

              <div className="d-flex justify-content-between align-items-center">
                <div className="">
                  <Icon className="text-red " size={29} icon={barChart} />
                </div>
                <span className="counter text-red">
                  {pieChartStatistics &&
                    pieChartStatistics.branches &&
                    pieChartStatistics.branches.totalBranches}
                </span>
              </div>
            </div>
          </Col>

          <Col className="Main-Graph-Card" xl={3} md={4} lg={4}>
            <div
              className="white-box shadow cardPointer"
              onClick={() => history.push("/reports/non-members")}
            >
              <h3 className="box-title">
                {_.get(
                  elements,
                  "landingPageElement.nonMemberCustomersElement",
                  "Non-Members (Customers)"
                )}
              </h3>
              <div className="d-flex justify-content-between align-items-center">
                <div className="">
                  <Icon className="text-red " size={29} icon={barChart} />
                </div>

                <span className="counter text-red">
                  {customerStatistics &&
                    customerStatistics.customers &&
                    customerStatistics.customers.totalCustomers}
                </span>
              </div>
            </div>
          </Col>

          <Col className="Main-Graph-Card" xl={3} md={4} lg={4}>
            <div
              className="white-box shadow cardPointer"
              onClick={() => history.push("/reports/members")}
            >
              <h3 className="box-title">
                {_.get(
                  elements,
                  "landingPageElement.membersElement",
                  "Members"
                )}
              </h3>
              <div className="d-flex justify-content-between align-items-center">
                <div className="">
                  <Icon className="text-red " size={29} icon={barChart} />
                </div>
                <span className="counter text-red">
                  {pieChartStatistics &&
                    pieChartStatistics.members &&
                    pieChartStatistics.members.totalMembers}
                </span>
              </div>
            </div>
          </Col>

          <Col className="Main-Graph-Card" xl={3} md={4} lg={4}>
            <div
              className="white-box shadow cardPointer"
              onClick={() => history.push("/reports/events")}
            >
              <h3 className="box-title">
                {_.get(elements, "landingPageElement.eventsElement", "Events")}
              </h3>
              <div className="d-flex justify-content-between align-items-center">
                <div className="">
                  <Icon className="text-red " size={29} icon={barChart} />
                </div>
                <span className="counter text-red">
                  {eventsStatistics &&
                    eventsStatistics.events &&
                    eventsStatistics.events.totalEvents}
                </span>
              </div>
            </div>
          </Col>

          <Col className="Main-Graph-Card" xl={3} md={4} lg={4}>
            <div
              className="white-box shadow cardPointer"
              onClick={() => history.push("/reports/rides")}
            >
              <h3 className="box-title">
                {_.get(elements, "landingPageElement.ridesElement", "Rides")}
              </h3>
              <div className="d-flex justify-content-between align-items-center">
                <div className="">
                  <Icon className="text-red " size={29} icon={barChart} />
                </div>
                <span className="counter text-red">
                  {ridesStatistics &&
                    ridesStatistics.rides &&
                    ridesStatistics.rides.totalRides}
                </span>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          {pieChartStatistics &&
          pieChartStatistics.branches &&
          pieChartStatistics.branches.totalBranches !== 0 ? (
            <Col xl={4} md={6} lg={6} xs={12} className="pb-4">
              <div className="white-box shadow whitebox_Height ">
                <h5 className="pie_heading">
                  {_.get(
                    elements,
                    "landingPageElement.branchesElement",
                    "Branches"
                  )}
                </h5>
                <Pie data={branchesData} width={100} height={50} />
              </div>
            </Col>
          ) : (
            <Col xl={4} md={6} lg={6} xs={12} className="pb-4">
              <div className="white-box shadow whitebox_Height position-relative  ">
                <h5 className="pie_heading">
                  {_.get(
                    elements,
                    "landingPageElement.branchesElement",
                    "Branches"
                  )}
                </h5>
                <div className="nodata_Text">
                  <span>No data to show</span>
                </div>
              </div>
            </Col>
          )}
          {customerStatistics &&
          customerStatistics.customers &&
          customerStatistics.customers.totalCustomers !== 0 ? (
            <Col xl={4} md={6} lg={6} xs={12} className="pb-4">
              <div className="white-box shadow whitebox_Height">
                <h5 className="pie_heading">
                  {_.get(
                    elements,
                    "landingPageElement.customersElement",
                    "Customers"
                  )}
                </h5>
                <Pie data={customersData} width={100} height={50} />
              </div>
            </Col>
          ) : (
            <Col xl={4} md={6} lg={6} xs={12} className="pb-4">
              <div className="white-box shadow whitebox_Height position-relative">
                <h5 className="pie_heading">
                  {_.get(
                    elements,
                    "landingPageElement.customersElement",
                    "Customers"
                  )}
                </h5>
                <div className="nodata_Text">
                  <span>No data to show</span>
                </div>
              </div>
            </Col>
          )}
          {pieChartStatistics &&
          pieChartStatistics.members &&
          pieChartStatistics.members.totalMembers !== 0 ? (
            <Col xl={4} md={6} lg={6} xs={12} className="pb-4">
              <div className="white-box shadow whitebox_Height ">
                <h5 className="pie_heading">
                  {_.get(
                    elements,
                    "landingPageElement.membersElement",
                    "Members"
                  )}
                </h5>
                <Pie data={membersData} width={100} height={50} />
              </div>
            </Col>
          ) : (
            <Col xl={4} md={6} lg={6} xs={12} className="pb-4">
              <div className="white-box shadow whitebox_Height position-relative">
                <h5 className="pie_heading">
                  {_.get(
                    elements,
                    "landingPageElement.membersElement",
                    "Members"
                  )}
                </h5>
                <div className="nodata_Text">
                  <span>No data to show</span>
                </div>
              </div>
            </Col>
          )}
        </Row>

        <Row>
          <Col xl={6} md={6} xs={12}>
            <Bar options={options} data={eventData} />
          </Col>

          <Col xl={6} md={6} xs={12}>
            <Bar options={options} data={rideData} />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default LandingPage;
